module.exports = __webpack_public_path__ + "img/рз_13.eb4b0238.png";